import { createAsyncThunk } from '@reduxjs/toolkit';

import { WPService } from 'api';

export const getMenu = createAsyncThunk('settings/getMenu', async () => {
	return await WPService.getMenu();
});
